export default __webpack_public_path__ + "static/media/liftInformation.e339095e.png";